export default "__VITE_PUBLIC_ASSET__4c935dda__"